import api from './api';
import { Provider } from '../types';

interface DependencyCheck {
  canDelete: boolean;
  reasons: string[];
}

export const providersService = {
  getAll: async (isActive?: boolean, includeDeleted?: boolean): Promise<Provider[]> => {
    const params: Record<string, boolean> = {};
    if (isActive !== undefined) params.isActive = isActive;
    if (includeDeleted) params.includeDeleted = true;
    const response = await api.get<Provider[]>('/providers', { params });
    return response.data;
  },

  getById: async (id: string): Promise<Provider> => {
    const response = await api.get<Provider>(`/providers/${id}`);
    return response.data;
  },

  create: async (data: Partial<Provider>): Promise<Provider> => {
    const response = await api.post<Provider>('/providers', data);
    return response.data;
  },

  update: async (id: string, data: Partial<Provider>): Promise<Provider> => {
    const response = await api.patch<Provider>(`/providers/${id}`, data);
    return response.data;
  },

  checkDependencies: async (id: string): Promise<DependencyCheck> => {
    const response = await api.get<DependencyCheck>(`/providers/${id}/check-dependencies`);
    return response.data;
  },

  // Soft delete (archive)
  delete: async (id: string): Promise<void> => {
    await api.delete(`/providers/${id}`);
  },

  // Restore from archive
  restore: async (id: string): Promise<Provider> => {
    const response = await api.post<Provider>(`/providers/${id}/restore`);
    return response.data;
  },

  // Permanent delete
  permanentDelete: async (id: string): Promise<void> => {
    await api.delete(`/providers/${id}/permanent`);
  },
};
